import React, { useEffect } from 'react';
import { CssBaseline } from '@mui/material';
import Reportmain from '../report';
import CustomizedDialogs from '../../../Components/CustomDialogs/Customizationdialog';
export default function FixedContainer() {

    const [open, setOpen] = React.useState(false)
    const [description, setDescription] = React.useState("")

    useEffect(() => {
        checkGroup()
        return () => {
        }
    }, [])
    const checkGroup = () => {
        if (localStorage.getItem("Permissiongroup").toLowerCase() !== "admin") {
            setOpen(true)
            setDescription("คุณไม่มีสิทธิ์ให้หน้านี้")
        }
    }
    const handleClose = () => {
        setOpen(false)
        _replacePage("/home")
    }
    const _replacePage = (e) => {
        window.location.replace(e);
    }
    return (
        <React.Fragment>
            <CssBaseline />
            <Reportmain />
            <CustomizedDialogs open={open} closedialog={e => handleClose()} description={description} title={""} buttontxt="" />
        </React.Fragment>
    );
}